<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit utsav' : 'Add utsav' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" id="utsav-form" (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Name</span>
        <input type="text" class="text-box-active" formControlName="name" />
      </div>
      <div class="field">
        <span class="field-label">Code</span>
        <input type="text" class="text-box-active" formControlName="utsavCode" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Utsav start</span>
        <input type="date" class="text-box-active" formControlName="utsavStartDate" />
      </div>
      <div class="field">
        <span class="field-label">Utsav end</span>
        <input type="date" class="text-box-active" formControlName="utsavEndDate" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Accommodation start</span>
        <input type="date" class="text-box-active" formControlName="accommodationStartDate" />
      </div>
      <div class="field">
        <span class="field-label">Accommodation end</span>
        <input type="date" class="text-box-active" formControlName="accommodationEndDate" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Booking start</span>
        <input type="date" class="text-box-active" formControlName="bookingStartDate" />
      </div>
      <div class="field">
        <span class="field-label">Booking end</span>
        <input type="date" class="text-box-active" formControlName="bookingEndDate" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Preview image</span>
        <div class="image-actions">
          <button type="button" class="ac-secondary-small-btn" (click)="pickImage()">
            {{ form.get('previewImgUrl')?.value ? 'Change image' : 'Select image' }}
          </button>
          @if(form.get('previewImgUrl')?.value){
          <button type="button" class="ac-secondary-small-btn" (click)="clearImage()">Remove</button>
          }
        </div>
        @if(form.get('previewImgUrl')?.value){
        <img class="preview-img" [src]="form.get('previewImgUrl')?.value" alt="Utsav preview" />
        } @else {
        <span class="hint">Pick one from the media library (Configurations › Media).</span>
        }
      </div>
      <div class="field">
        <span class="field-label">Location URL</span>
        <input type="text" class="text-box-active" formControlName="locationUrl" />
      </div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="submit" form="utsav-form" class="ac-primary-btn" [disabled]="isLoading">
      {{ isEdit ? 'Save' : 'Add' }}
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
